// extracted by mini-css-extract-plugin
export var container = "_c5-1";
export var cornerButtonContainer = "_c5-5";
export var disabled = "_c5-2";
export var fileContainer = "_c5-4";
export var hiddenInput = "_c5-3";
export var widthContainer = "_c5-0";